import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { trackEvent } from '@/lib/analytics';

declare global {
  interface Window {
    setAnalyticsConsent?: (granted: boolean) => void;
  }
}

const CONSENT_KEY = 'lme_analytics_consent';

export const AnalyticsRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent('page_view', {
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}`,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};

const ConsentBanner = () => {
  const [visible, setVisible] = useState(() => localStorage.getItem(CONSENT_KEY) === null);

  if (!visible) return null;

  const decide = (granted: boolean) => {
    window.setAnalyticsConsent?.(granted);
    setVisible(false);
  };

  return (
    <aside
      aria-label="Pilihan privasi analytics"
      className="fixed inset-x-3 bottom-3 z-[100] mx-auto max-w-3xl border border-border bg-background p-2 shadow-2xl sm:flex sm:items-center sm:gap-5 sm:p-4"
    >
      <p className="text-[11px] leading-4 text-muted-foreground sm:flex-1 sm:text-xs sm:leading-6">
        Analytics membantu kami memperbaiki situs. Data tidak dijual; personalisasi iklan tetap nonaktif.{' '}
        <Link className="text-foreground underline underline-offset-4" to="/privacy">Detail privasi</Link>.
      </p>
      <div className="mt-2 flex shrink-0 gap-2 sm:mt-0">
        <button
          type="button"
          onClick={() => decide(false)}
          className="min-h-11 flex-1 border border-border px-2 py-2 text-center text-[10px] font-bold uppercase tracking-wider hover:bg-muted sm:min-h-0 sm:flex-none sm:px-4"
        >
          Hanya perlu
        </button>
        <button
          type="button"
          onClick={() => decide(true)}
          className="min-h-11 flex-1 border border-foreground bg-foreground px-2 py-2 text-center text-[10px] font-bold uppercase tracking-wider text-background hover:opacity-90 sm:min-h-0 sm:flex-none sm:px-4"
        >
          Izinkan analytics
        </button>
      </div>
    </aside>
  );
};

export default ConsentBanner;
